import { FormattedMessage } from 'react-intl';
import { config, getAssetUrl } from '../../../../utils/config';
import Button from '../../../atoms/Button';
import './style.scss';

type Party = 'apple' | 'facebook';

export const getThirdParties = () =>
  Object.entries(config.features.thirdPartySignIn).reduce((parties: Party[], partyObj) => {
    if (partyObj[1].enabled) {
      parties.push(partyObj[0] as Party);
    }
    return parties;
  }, []);

const ThirdPartySignIn = ({ parties }: { parties: Party[] }) => (
  <div className="form__row auth-form__row">
    {parties.map(party => (
      <div className="form__field-container" key={party}>
        <Button
          type="button"
          className={`party party--${party}`}
          onClick={() => console.log(`${party} login clicked`)}
          data-test-id={`register-${party}`}
        >
          <img src={getAssetUrl(`login/${party}.svg`)} alt={party} />
          <FormattedMessage id={`auth.continueWith${party.charAt(0).toUpperCase() + party.slice(1)}`} />
        </Button>
      </div>
    ))}
  </div>
);

export default ThirdPartySignIn;
